import React from 'react';
import { useHistory } from 'react-router-dom';
import { DocsIcon, UsersIcon, VehicleIcon } from 'components/icons/Icons';
import { useTranslation } from 'react-i18next';
import 'styles/pages/WelcomePage.scss';
import AppContext from 'contexts/AppContext';
import ProfileTypes from 'types/enums/ProfileTypes';

export default (): JSX.Element => {
  const history = useHistory();
  const { authData } = React.useContext(AppContext);
  const { t } = useTranslation();

  return (
    <>
      <section className="Starting">
        <h1>{t('welcome')}</h1>
        <p>{t('click-to-start')}</p>
      </section>
      <section className="Container">
        {authData?.user.profileTypeId === ProfileTypes.Admin && (
          <div
            className="Tool"
            onClick={() => {
              history.push('/private/venues');
            }}
          >
            <VehicleIcon />
            <strong>{t('venues')}</strong>
          </div>
        )}
        {(authData?.user.showUserSection ||
          authData?.user.showUserSplashSection ||
          authData?.user.profileTypeId === ProfileTypes.Admin) && (
          <div
            className="Tool"
            onClick={() => {
              history.push('/private/users');
            }}
          >
            <UsersIcon />
            <strong>{t('users')}</strong>
          </div>
        )}

        {(authData?.user.showSplashSection ||
          authData?.user.showUserSplashSection ||
          authData?.user.profileTypeId === ProfileTypes.Admin) && (
          <div
            className="Tool"
            onClick={() => {
              history.push('/private/splashes');
            }}
          >
            <DocsIcon />
            <strong>{t('splashes')}</strong>
          </div>
        )}

        {authData?.user.profileTypeId === ProfileTypes.Admin && (
          <div
            className="Tool"
            onClick={() => {
              history.push('/private/user-editors');
            }}
          >
            <UsersIcon />
            <strong>{t('venue-editors')}</strong>
          </div>
        )}
      </section>
    </>
  );
};
